import React, { useCallback } from 'react';

import { useTranslation } from '@lyearn/i18n';
import { MenuListItems } from '@lyearn/molecules';
import { TableOptionsProps } from '@/modules/corporate/modules/database/fields/types';
import { TableViewActionTypes } from '@/modules/corporate/modules/database/views/TableView/hooks/useTableViewActions/actions';
import { DatabaseRatingTypeEnum } from '@/types/schema';

import getRatingOptions from './getRatingOptions';

const TableOptions = (props: TableOptionsProps) => {
  const { toggle, onAction, column } = props;
  const { t } = useTranslation();
  const ratingType = column.field.metadataField.ratingType || DatabaseRatingTypeEnum.Star;

  const onItemClick = useCallback(
    (type: string) => {
      onAction({
        type: TableViewActionTypes.UpdateDatabaseMetadataField,
        payload: {
          fieldId: column.field.metadataField.fieldId,
          updates: {
            ratingType: type as DatabaseRatingTypeEnum,
          },
        },
      });
      toggle();
    },
    [column.field.metadataField.fieldId, onAction, toggle],
  );

  return <MenuListItems items={getRatingOptions(t, ratingType)} onAction={onItemClick} />;
};

export default TableOptions;
